import {useState} from "react";

export type sort = {[field: string]: "ASC" | "DESC"};

export const DEF_SORT = "name,ASC,createdAt,ASC";
export const DEF_SORT_OBJ: sort = {
  name: "ASC",
  createdAt: "ASC",
};

const useSearchParams = (initSearchParams: URLSearchParams) => {
  const [searchParams, setSearchParams] =
    useState<URLSearchParams>(initSearchParams);

  const updateSearchParams = (key: string, value: string | undefined) => {
    setSearchParams(params => {
      const newParams = new URLSearchParams(params.toString());
      if (value) {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
      return new URLSearchParams(newParams.toString());
    });
  };

  const search = (text: string) => {
    setSearchParams(params => {
      const newParams = new URLSearchParams(params.toString());
      newParams.set("name", text);
      newParams.set("page", "0");
      return new URLSearchParams(newParams.toString());
    });
  };

  const clear = () => {
    setSearchParams(params => {
      const newParams = new URLSearchParams(params.toString());
      newParams.delete("name");
      return new URLSearchParams(newParams.toString());
    });
  };

  const paginate = (page: number, size: number) => {
    setSearchParams(params => {
      const newParams = new URLSearchParams(params.toString());
      newParams.set("page", page.toString());
      newParams.set("size", size.toString());
      return new URLSearchParams(newParams.toString());
    });
  };

  const sort = (sort: string) => {
    setSearchParams(params => {
      const newParams = new URLSearchParams(params.toString());
      if (sort) {
        newParams.set("sort", sort);
      } else {
        newParams.delete("sort");
      }
      return new URLSearchParams(newParams.toString());
    });
  };

  return {
    searchParams,
    search,
    clear,
    paginate,
    sort,
    updateSearchParams,
  };
};

export {useSearchParams};
